export enum Sources {
  jobTracking = 'job-tracking',
  jobSearch = 'job-search',
  interviewPrep = 'interview-prep',
}
